export const clinicas = [
  {
    nombre: 'Clínica Dental Madrid Centro',
    ubicacion: 'Madrid',
    rating: '4.9',
    especialidades: 'Invisalign, Ortodoncia Lingual',
    imagen: 'https://public.readdy.ai/ai/img_res/612fc27893ee99d9b0319d0f9941e0f8.jpg',
    web: 'https://clinicadentalmadridcentro.es'
  },
  {
    nombre: 'Barcelona Smile Center',
    ubicacion: 'Barcelona',
    rating: '4.8',
    especialidades: 'Ortodoncia Estética, Brackets',
    imagen: 'https://readdy.ai/api/search-image?query=elegant%20dental%20clinic%20interior%20reception%20area%20modern%20minimalist%20design%20white%20walls%20comfortable%20seating%20natural%20light%20professional%20medical%20facility%20clean%20contemporary%20space%20welcoming%20atmosphere&width=800&height=800&seq=clinic-002&orientation=squarish',
    web: 'https://barcelonasmilecenter.com'
  },
  {
    nombre: 'E2 Dental Clinic',
    ubicacion: 'Palma de Mallorca',
    rating: '4.9',
    especialidades: 'Ortodoncia Invisible, Implantología, Estética Dental',
    imagen: 'https://e2.clinic/og-image.jpg',
    destacada: true,
    telefono: '+34 871 90 62 42',
    direccion: 'Carrer de Joan de Cremona, 3, 07012 Palma',
    experiencia: '15+ años',
    pacientes: '12.000+',
    satisfaccion: '98%',
    web: 'https://e2.clinic'
  },
  {
    nombre: 'Ortodoncia Valencia',
    ubicacion: 'Valencia',
    rating: '4.9',
    especialidades: 'Ortodoncia Infantil, Brackets',
    imagen: 'https://readdy.ai/api/search-image?query=modern%20dental%20clinic%20treatment%20room%20professional%20dental%20chair%20advanced%20equipment%20clean%20white%20interior%20bright%20lighting%20medical%20facility%20contemporary%20design%20sterile%20environment%20high%20tech%20dental%20office&width=800&height=800&seq=clinic-003&orientation=squarish',
    web: 'https://ortodonciavalencia.es'
  },
  {
    nombre: 'Sevilla Dental Excellence',
    ubicacion: 'Sevilla',
    rating: '4.7',
    especialidades: 'Invisalign, Ortodoncia Digital',
    imagen: 'https://readdy.ai/api/search-image?query=luxury%20dental%20clinic%20consultation%20room%20modern%20interior%20design%20comfortable%20patient%20area%20natural%20lighting%20professional%20medical%20facility%20clean%20contemporary%20space%20high%20end%20dental%20office%20welcoming%20atmosphere&width=800&height=800&seq=clinic-004&orientation=squarish',
    web: 'https://sevilladentalexcellence.com'
  },
  {
    nombre: 'Bilbao Ortodoncia Avanzada',
    ubicacion: 'Bilbao',
    rating: '4.8',
    especialidades: 'Ortodoncia Lingual, Estética',
    imagen: 'https://readdy.ai/api/search-image?query=contemporary%20dental%20clinic%20waiting%20area%20modern%20minimalist%20design%20comfortable%20seating%20natural%20light%20professional%20medical%20facility%20clean%20white%20interior%20welcoming%20reception%20space&width=800&height=800&seq=clinic-005&orientation=squarish',
    web: 'https://bilbaoortodoncia.es'
  },
  {
    nombre: 'Málaga Smile Studio',
    ubicacion: 'Málaga',
    rating: '4.9',
    especialidades: 'Invisalign, Brackets Estéticos',
    imagen: 'https://readdy.ai/api/search-image?query=modern%20dental%20clinic%20exterior%20building%20contemporary%20architecture%20clean%20design%20professional%20medical%20facility%20bright%20daylight%20urban%20location%20welcoming%20entrance%20high%20end%20dental%20office&width=800&height=800&seq=clinic-006&orientation=squarish',
    web: 'https://malagasmilestudio.com'
  },
  {
    nombre: 'Zaragoza Dental Care',
    ubicacion: 'Zaragoza',
    rating: '4.7',
    especialidades: 'Ortodoncia Infantil, Brackets',
    imagen: 'https://readdy.ai/api/search-image?query=bright%20dental%20clinic%20interior%20modern%20treatment%20area%20professional%20dental%20equipment%20clean%20white%20walls%20natural%20lighting%20medical%20facility%20contemporary%20design%20sterile%20environment&width=800&height=800&seq=clinic-007&orientation=squarish',
    web: 'https://zaragozadentalcare.es'
  }
];
